import React from "react"
import Layout from "components/layout"
import usePageData from "hooks/queryCommunityPage"
import ViewCommunity from "components/ViewCommunity";

const CommunityPage = props => {
  const { pageContext } = props;
  const pageData = usePageData();

  return (
    <Layout pageContext={pageContext}>
      <ViewCommunity pageData={pageData} />
    </Layout>
  )
}

export default CommunityPage
